import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { formatCurrency } from '../../../../../helpers/numbers'
import { getBudgetSectionType } from '../../../../Multiplatform/CampaignForms/typeHelpers'

import { selectedFacebookAdAccountSelector } from '../../../../../modules/selectors/adAccounts'

import { BUDGET_DAILY, BUDGET_LIFETIME, NO_BUDGET } from '../../../../Multiplatform/CampaignForms/fields'

const CampaignBudgetSectionPreview = ({ campaign }) => {
  const { t } = useTranslation()

  const { currency_symbol } = useSelector(selectedFacebookAdAccountSelector)

  const { budget_lifetime: initialBudgetLifetime, budget_daily: initialBudgetDaily } = campaign
  const budgetType = getBudgetSectionType(initialBudgetLifetime, initialBudgetDaily)

  const formattedLifetimeBudget = formatCurrency(initialBudgetLifetime, { min: 2, max: 2 }, { symbol: currency_symbol })

  const formattedDailyBudget = formatCurrency(initialBudgetDaily, { min: 2, max: 2 }, { symbol: currency_symbol })

  if (budgetType === BUDGET_LIFETIME) {
    return (
      <p>
        {formattedLifetimeBudget} ({t('Lifetime')})
      </p>
    )
  }

  if (budgetType === BUDGET_DAILY) {
    return (
      <p>
        {formattedDailyBudget} ({t('Daily')})
      </p>
    )
  }

  if (budgetType === NO_BUDGET) {
    return <p>{t('Using ad set budgets')}</p>
  }

  return null
}

CampaignBudgetSectionPreview.propTypes = {
  campaign: PropTypes.object.isRequired
}

export default CampaignBudgetSectionPreview
